import {categoryColor} from 'utils/Helper';

export default theme => ({
  root: {
    borderRadius: '3px',
    '-moz-border-radius': '3px',
    '-webkit-border-radius': '3px',
    margin: '0 5px',
    fontSize: 11,
    padding: '0 5px',
    display: 'inline-block',
    // border: '1px solid #e0e0e0',
    border: '1px solid transparent',
    lineHeight: 1.7,

    backgroundColor: categoryColor('id', 'primary', 500),
    borderColor: categoryColor('id', 'primary', 600),
    color: categoryColor('id', 'primary', 50, '#333'),
    '&:hover': {
      backgroundColor: categoryColor('id', 'primary', 400),
      borderColor: categoryColor('id', 'primary', 600),
    },
    '&:visited, &:hover, &:visited:hover': {
      color: categoryColor('id', 'primary', 50, '#333'),
    }
  }
});

